import React from "react";
import PT from "prop-types";
import styled from "styled-components";

import { down, global, spacings } from "~/src/config/vars";

const Container = ({ children, size = "small" }) => {
    return <SContainer className={size}>{children}</SContainer>;
};

Container.propTypes = {
    children: PT.any.isRequired,
    size: PT.oneOf(["small", "large"]),
};

const SContainer = styled.div`
    width: 100%;
    padding-right: ${spacings?.offset_wrapper};
    padding-left: ${spacings?.offset_wrapper};
    margin-right: auto;
    margin-left: auto;
    &.small {
        max-width: calc(
            720px + (${spacings?.offset_wrapper} + ${spacings?.offset_wrapper})
        );
    }
    &.large {
        max-width: ${global?.container_width};
        ${down("lg")} {
            max-width: 100%;
        }
    }
`;

export default Container;
